import { Http } from '../../common/api';
import { PricingApiConfiguration } from '../models/pricing-api-configuration';

let PRICING_API_API_CONFIG: PricingApiConfiguration = {
  baseUrl: '',
  isSFCCPricingOn: false,
  shopApiClientId: '',
  marketLocale: '',
};

export const pricingHttp = new Http();

export const getPricingApiConfig = (): PricingApiConfiguration => {
  return { ...PRICING_API_API_CONFIG };
};

const mapNonISOMarketToISOMarket = (market: string) => {
  // sfcc market locale requires ISO format - en-APAC and en-EMEA are not valid
  if (market === 'en-APAC') {
    return 'en-ID';
  } else if (market === 'en-EMEA') {
    return 'en-BE';
  }
  return market;
};

export const initializePricingHttp = (config: PricingApiConfiguration): void => {
  PRICING_API_API_CONFIG = {
    ...PRICING_API_API_CONFIG,
    ...config,
    marketLocale: config.marketLocale
      ? mapNonISOMarketToISOMarket(config.marketLocale)
      : PRICING_API_API_CONFIG.marketLocale,
  };

  pricingHttp.initializeHttp(config.baseUrl);
};

export const isPricingApiConfigured = (): boolean => {
  return pricingHttp.isReady();
};
